export const SERVICES = {
  reservations: 'https://www.sevenrooms.com/reservations/skilletz',
  careers: 'https://zippyapp.com/biz/skilletz',
  tripadvisor:
    'https://www.tripadvisor.com/Restaurant_Review-g32411-d14979469-Reviews-Skillet_z_Cafe-Fremont_California.html',
  catering:
    'https://docs.google.com/document/d/16e_c_6yw3ibc7KPSYJYKBUj1eIw74LM1YBLEFLdrb2A/preview',
  schoolFundraiserBooking: 'https://calendar.app.google/y7yctEV4McQQxGY57',
} as const;
